package uz.ferro.erp.locale

enum class Language {
    UZ_LAT,
    UZ_CYR,
    EN,
    RU;

    companion object {
        fun getByString(stringVal: String?): Language {
            return entries.firstOrNull { it.name.lowercase() == stringVal.orEmpty().lowercase() }
                ?: UZ_LAT
        }
    }
}